import { render, staticRenderFns } from "./CodeBlockComponent.vue?vue&type=template&id=d7479de0&"
import script from "./CodeBlockComponent.vue?vue&type=script&lang=js&"
export * from "./CodeBlockComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports